<template>
  <div>
    <v-divider></v-divider>

    <v-list
      subheader
      two-line
    >
      <v-subheader>{{ inputName }}</v-subheader>

      <v-list-item-group
        multiple
        active-class=""
        class="px-6"
      >
        <image-file-input-viewer
          class="mt-2"
          maxHeight="150"
          label="Section BG image"
          v-model="sectionData.bg_thumbnail"
          :clearable="true"
        />

        <v-checkbox
          label="Hide BG Image"
          v-show="sectionData.bg_thumbnail"
          v-model="sectionData.hide_bg_image"
        />
        <color-picker
          label="Section BG color"
          v-bind:color.sync="sectionData.bg_color"
        />

        <v-switch
          color="primary"
          label="Open link on new tab?"
          v-model="sectionData.is_new_tab"
        />
      </v-list-item-group>
    </v-list>
    <v-divider></v-divider>
    <v-list
      flat
      subheader
    >
      <v-subheader>Content</v-subheader>

      <v-list-item-group
        multiple
        active-class=""
        class="px-6"
      >
        <v-text-field
          v-model="sectionData[sectionData.type].text"
          outlined
          label="Button Text"
          dense
          :errorMessages="btnTextError(head(errorMessages['page_sections.'+ currIndex + '.page_button.text' ]))"
        />

        <v-text-field
          v-model="sectionData[sectionData.type].url"
          outlined
          label="URL"
          dense
          :errorMessages="btnUrlError(head(errorMessages['page_sections.'+ currIndex + '.page_button.url' ]))"
        />

        <color-picker
          label="Button color"
          v-bind:color.sync="sectionData[sectionData.type].color"
        />

        <color-picker
          label="Button text color"
          v-bind:color.sync="sectionData[sectionData.type].txt_color"
        />

        <v-text-field
          v-model="sectionData[sectionData.type].txt_size"
          outlined
          label="Button Text Size (px)"
          dense
          type="number"
        />

        <v-text-field
          v-model="sectionData[sectionData.type].width"
          outlined
          label="Width (px)"
          dense
          type="number"
        />

        <v-select
          outlined
          label="Align"
          dense
          :items="alignOptions"
          v-model="sectionData[sectionData.type].align"
        />

        <v-checkbox
          v-model="sectionData[sectionData.type].is_blocked"
          label="Full Width"
          v-show="false"
        />

        <label class="subtitle-1 pb-3 pt-1 mt-4">Button size</label>
        <v-row>
          <v-col>
            <v-checkbox
              label="Blocked"
              v-model="sectionData[sectionData.type].is_blocked"
              @change="updateBtnSize('is_blocked', $event)"
            />
          </v-col>
          <v-col>
            <v-checkbox
              label="XS"
              v-model="sectionData[sectionData.type].is_xsmall"
              @change="updateBtnSize('is_xsmall', $event)"
            />
          </v-col>
          <v-col>
            <v-checkbox
              label="S"
              v-model="sectionData[sectionData.type].is_small"
              @change="updateBtnSize('is_small', $event)"
            />
          </v-col>
          <v-col>
            <v-checkbox
              label="M"
              v-model="sectionData[sectionData.type].is_medium"
              @change="updateBtnSize('is_medium', $event)"
            />
          </v-col>
          <v-col>
            <v-checkbox
              label="L"
              v-model="sectionData[sectionData.type].is_large"
              @change="updateBtnSize('is_large', $event)"
            />
          </v-col>
          <v-col>
            <v-checkbox
              label="XL"
              v-model="sectionData[sectionData.type].is_xlarge"
              @change="updateBtnSize('is_xlarge', $event)"
            />
          </v-col>
        </v-row>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import ColorPicker from '@/components/ColorPicker'
import head from 'lodash/head'
import ImageFileInputViewer from '@/components/ImageFileInputViewer'

export default {
  name: 'PageButton',
  data () {
    return {
      alignOptions: [
        {
          text: 'Center',
          value: 'center'
        },
        {
          text: 'Left',
          value: 'left'
        },
        {
          text: 'Right',
          value: 'right'
        }
      ]
    }
  },
  components: {
    ColorPicker,
    ImageFileInputViewer
  },
  props: {
    sectionData: {
      type: Object,
      default () {
        return {}
      }
    },
    inputName: {
      type: String,
      default: ''
    },
    errorMessages: {
      type: [String, Array, Object],
      default () {
        return null
      }
    },
    currIndex: {
      type: [String, Number],
      default: null
    }
  },
  methods: {
    head,
    setDefaults () {
      if (!this.sectionData[this.sectionData.type].color) {
        this.sectionData[this.sectionData.type].color = '#3F51B5'
      }
    },
    updateBtnSize (size, event) {
      if (size === 'is_blocked' && event === true) {
        this.sectionData[this.sectionData.type].is_blocked = true
        this.sectionData[this.sectionData.type].is_xsmall = false
        this.sectionData[this.sectionData.type].is_small = false
        this.sectionData[this.sectionData.type].is_medium = false
        this.sectionData[this.sectionData.type].is_large = false
        this.sectionData[this.sectionData.type].is_xlarge = false
      } else if (size === 'is_xsmall' && event === true) {
        this.sectionData[this.sectionData.type].is_blocked = false
        this.sectionData[this.sectionData.type].is_xsmall = true
        this.sectionData[this.sectionData.type].is_small = false
        this.sectionData[this.sectionData.type].is_medium = false
        this.sectionData[this.sectionData.type].is_large = false
        this.sectionData[this.sectionData.type].is_xlarge = false
      } else if (size === 'is_small' && event === true) {
        this.sectionData[this.sectionData.type].is_blocked = false
        this.sectionData[this.sectionData.type].is_xsmall = false
        this.sectionData[this.sectionData.type].is_small = true
        this.sectionData[this.sectionData.type].is_medium = false
        this.sectionData[this.sectionData.type].is_large = false
        this.sectionData[this.sectionData.type].is_xlarge = false
      } else if (size === 'is_medium' && event === true) {
        this.sectionData[this.sectionData.type].is_blocked = false
        this.sectionData[this.sectionData.type].is_xsmall = false
        this.sectionData[this.sectionData.type].is_small = false
        this.sectionData[this.sectionData.type].is_medium = true
        this.sectionData[this.sectionData.type].is_large = false
        this.sectionData[this.sectionData.type].is_xlarge = false
      } else if (size === 'is_large' && event === true) {
        this.sectionData[this.sectionData.type].is_blocked = false
        this.sectionData[this.sectionData.type].is_xsmall = false
        this.sectionData[this.sectionData.type].is_small = false
        this.sectionData[this.sectionData.type].is_medium = false
        this.sectionData[this.sectionData.type].is_large = true
        this.sectionData[this.sectionData.type].is_xlarge = false
      } else if (size === 'is_xlarge' && event === true) {
        this.sectionData[this.sectionData.type].is_blocked = false
        this.sectionData[this.sectionData.type].is_xsmall = false
        this.sectionData[this.sectionData.type].is_small = false
        this.sectionData[this.sectionData.type].is_medium = false
        this.sectionData[this.sectionData.type].is_large = false
        this.sectionData[this.sectionData.type].is_xlarge = true
      } else {
        this.sectionData[this.sectionData.type].is_blocked = false
        this.sectionData[this.sectionData.type].is_xsmall = false
        this.sectionData[this.sectionData.type].is_small = false
        this.sectionData[this.sectionData.type].is_medium = false
        this.sectionData[this.sectionData.type].is_large = false
        this.sectionData[this.sectionData.type].is_xlarge = false
      }
    },
    btnTextError (errorString) {
      if (errorString) {
        return 'Button Text is required!'
      } else {
        return null
      }
    },
    btnUrlError (errorString) {
      if (errorString) {
        return 'Button URL format is invalid!'
      } else {
        return null
      }
    }
  },
  created () {
    // this.setDefaults()
  }

}
</script>

<style scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.withdrawal-options {
  margin-top: 20px;
}
</style>
